export enum ProjectTypeEnum {
  PETITS_PROJETS = 'PETITS_PROJETS',
  
  ARCHI_RESIDENCE = 'ARCHI_RESIDENCE',
  ARCHI_HOTEL_RESTAURANT = 'ARCHI_HOTEL_RESTAURANT',
  ARCHI_RETAIL = 'ARCHI_RETAIL',
  SCENOGRAPHY = 'SCENOGRAPHY',
  INSTITUTION = 'INSTITUTION',

  PROJECT_ROOM = 'PROJECT_ROOM',
  TINY_ROOM = 'TINY_ROOM',

  DESIGN_COLLABORATIONS = 'DESIGN_COLLABORATIONS'
}
